import { defineFcm } from '../shared/factory';

export const FCM_COMMS_STACK_TEMPLATE_EXPERIMENTATION_ENABLED = defineFcm(
	'comms_stack_template_experimentation_enabled',
)
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-site-platform',
		scope: 'comms-stack',
		context: 'comms stack',
		description: 'Global flag to enable template experimentation in emails.',
		import: false,
	});
